import { cvFragment } from './cv';
import { basicJobPostingFragment } from './basicJobPosting';
import { extendedJobPostingFragment } from './extendedJobPosting';

export { cvFragment, basicJobPostingFragment, extendedJobPostingFragment };
